import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { fetchTournamentDetail } from 'modules/jogador/tournaments/tournamentsService';

export function useTournamentDetail() {
  const { tournamentId } = useParams<{ tournamentId: string }>();

  const { data: tournament, isLoading, error } = useAsyncData(
    () => (tournamentId ? fetchTournamentDetail(tournamentId) : Promise.resolve(undefined)),
    undefined,
    [tournamentId]
  );

  const firstAvailableCategory = tournament?.categories.find((category) => category.status !== 'full');
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
  const [paymentChoice, setPaymentChoice] = useState<'integral' | 'dividido' | null>(null);

  return {
    tournament,
    isLoading,
    error,
    selectedCategoryId: selectedCategoryId ?? firstAvailableCategory?.id ?? null,
    setSelectedCategoryId,
    paymentChoice,
    setPaymentChoice,
  };
}
